<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :ripple="false"
        class="no-background-hover"
        style="height:24px !important;width:24px !important"
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil 
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="PCB statement"
      text="Update PCB Statement"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pcb-0"
          >
            <v-text-field
              v-model="localPcbStatement.pcb_amount"
              label="PCB Amount"
              prefix="RM"
              disabled
              class="disabled-background"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pcb-0"
          >
            <v-text-field
              v-model="localPcbStatement.cp38_amount"
              label="CP38 Amount"
              prefix="RM"
              disabled
              class="disabled-background"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pcb-0"
          >
            <v-text-field
              v-model="localPcbStatement.pcb_receipt_no"
              label="PCB Receipt/Bank Slip/Transaction No"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pcb-0"
          >
            <v-text-field
              v-model="localPcbStatement.cp38_receipt_no"
              label="PCB Receipt/Bank Slip/Transaction No"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pcb-0"
          >
            <v-menu
              v-model="pcbTransactionDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="localPcbStatement.pcb_transaction_date"
                  label="PCB transaction date"
                  outlined
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localPcbStatement.pcb_transaction_date"
                no-title
                @input="pcbTransactionDateMenu = false"
              /> 
            </v-menu> 
          </v-col>
          <v-col
            cols="12"
            class="pcb-0"
          >
            <v-menu
              v-model="cp38TransactionDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="localPcbStatement.cp38_transaction_date"
                  label="CP38 transaction date"
                  outlined
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localPcbStatement.cp38_transaction_date"
                no-title
                @input="cp38TransactionDateMenu = false"
              /> 
            </v-menu> 
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"    
          class="white--text px-10" 
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      pcbStatement: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localPcbStatement: null,
        pcbTransactionDateMenu: false,
        cp38TransactionDateMenu: false,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.localPcbStatement = { ...this.pcbStatement }

        if (this.localPcbStatement.pcb_amount) { this.localPcbStatement.pcb_amount = (Math.round((this.localPcbStatement.pcb_amount / 100) * 100) / 100).toFixed(2) }
        if (this.localPcbStatement.cp38_amount) { this.localPcbStatement.cp38_amount = (Math.round((this.localPcbStatement.cp38_amount / 100) * 100) / 100).toFixed(2) }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)   

            this.$api.companyEmployeePcbStatements().update(this.pcbStatement.id, this.prepareFormData())
              .then(res => {
                this.$emit('updated')
                this.$snack({ message: res.data.status })

                this.dialog = false

                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          pcb_receipt_no: this.localPcbStatement.pcb_receipt_no,
          cp38_receipt_no: this.localPcbStatement.cp38_receipt_no,
          pcb_transaction_date: this.localPcbStatement.pcb_transaction_date,
          cp38_transaction_date: this.localPcbStatement.cp38_transaction_date,
        }
      },
    },    
  }
</script>

<style scoped>
.no-background-hover::before {
  background-color: transparent !important; 
}
.disabled-background >>> .v-input__slot{
  background: #f0f0f0
}
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
